import * as React from "react";
import { Phases, validRoutes } from "../routeConfig";
import { getMatchingPath } from "../utils/typeUtils";
import { useLocation } from "react-router-dom";
export default function useRouteConfig() {
    var pathname = useLocation().pathname;
    return React.useMemo(function () {
        var matchingPath = getMatchingPath(pathname, validRoutes);
        return Phases[matchingPath];
    }, [pathname]);
}
